import React from "react";
import DateControl from "./DateControl";
import Field from "./Field";
import { FieldProps } from "./Types";

const DateField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <DateControl {...controlProps} disabled={disabled} />
        </Field>
    );
}

export default DateField;
